import { type Lesson } from '@/models/Lesson';
import { Milestone } from '@/models/Milestone';

import fetch from '@/utils/fetch';

import { getLessonEndpoint, getLessonMilestonesEndpoint } from './endpoints';

export const getLessonContent = async (lessonId: number): Promise<Lesson> => {
  const response = await fetch(getLessonEndpoint(lessonId));
  const data: Lesson = await response.json();

  return data;
};

export const getLessonMilestones = async (lessonId: number): Promise<Milestone[]> => {
  const response = await fetch(getLessonMilestonesEndpoint(lessonId));
  const data: Milestone[] = await response.json();

  return data;
};

export const scrollIntoLessonStep = (stepId: string) => {
  document
    .querySelector(`[data-lesson-step-id="${stepId}"]`)
    ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
